module.exports = __webpack_public_path__ + "static/media/groupon.1d327a84.svg";